import { SharedConstants } from '@formbird/types';
import { SearchResultsProcessor, UtilIncludeRuleSet } from '@formbird/shared';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { DataService } from '../data/data.service';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class ClientIncludeRuleSetService {

  constructor(
    private configService: ConfigService,
    private dataService: DataService
  ) {
  }

  private loadIncludeDocs(includeNames, callback) {
    const searchProviderName = this.configService.clientConfig().defaultSearchProvider;
    let query;

    if (searchProviderName === SharedConstants.SEARCH_PROVIDERS.COUCHBASE) {
      let statement = 'SELECT * FROM <bucketName> WHERE systemHeader.systemType=\'' + SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE + '\'';
      statement += ' AND name in ' + JSON.stringify(includeNames);
      query = { query: statement };
    } else {

      query = {
        'query': {
          'bool': {
            'must': [
              { 'term': { 'systemHeader.systemType': SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE } },
              { 'term': { 'systemHeader.currentVersion': true } }
            ]
          }
        }
      };

      if (includeNames && includeNames.length > 0) {
        query.query.bool.must.push({ 'terms': { 'name': includeNames } });
      }
    }

    this.dataService.findByElastic(query).then(
      function(data) {

        SearchResultsProcessor.processSearchResults(data,
          function elementProcessing(doc) {
          },
          function complete(docs, totalHits) {
            const tmpData = { data: docs, total: totalHits };
            callback(null, tmpData);
          }
        );

      },
      function(err) {
        logger.warn(err);
        callback(err);
      }
    );
  }

  /*
   * Including ruleset processing.
   * Include ruleset syntax: #include "rulesetName";
   */
  addIncludesToRuleset(ruleFlow, callback) {

    const includeNames = UtilIncludeRuleSet.getIncludeNames(ruleFlow);

    if (includeNames && includeNames.length) {

      const remainIncludeNames = [];

      // remove commented #include
      for (let i = 0; i < includeNames.length; i++) {

        const beforeLength = ruleFlow.length;
        const commentLineExp = '//[\t ]*#include[\t ]+[\'"]' + includeNames[i] + '[\'"][\t ]*.*';
        ruleFlow = ruleFlow.replace(new RegExp(commentLineExp, 'g'), '');

        if (beforeLength === ruleFlow.length) {
          // Keep not commented include name
          remainIncludeNames.push(includeNames[i]);
        }
      }

      if (remainIncludeNames.length) {

        this.loadIncludeDocs(remainIncludeNames, (error, result) => {

          if (error) {

            callback({
              status: SharedConstants.STATUS_ERROR,
              message: 'Error loading include ruleset: ' + error.message
            });

          } else if (result && result.total && result.total === remainIncludeNames.length) {

            for (let id = 0; id < result.total; id++) {
              const includeDoc = result.data[id];

              // replace #include by script for JS
              const exp = '#include[\t ]+[\'"]' + includeDoc.name + '[\'"][\t ]*,';
              ruleFlow = ruleFlow.replace(new RegExp(exp, 'g'), includeDoc.ruleSetSnippet + ',');
            }

            callback({
              status: SharedConstants.STATUS_SUCCESS,
              ruleFlow: ruleFlow
            });

          } else {

            let missedIncludes;

            if (result && result.total) {

              missedIncludes = [];

              for (let i = 0; i < remainIncludeNames.length; i++) {

                let res = false;

                for (let j = 0; j < result.total; j++) {

                  if (result.data[j].name === remainIncludeNames[i]) {
                    res = true;
                    break;
                  }
                }

                if (!res) {
                  missedIncludes.push(remainIncludeNames[i]);
                }
              }

            } else {
              missedIncludes = remainIncludeNames;
            }

            logger.error('There are missing ruleset includes for this document: ' + missedIncludes +
              '. Please make sure the ruleset include documents exist and ' +
              'the correct access keys are configured for them.');

            let errMsg = 'Ruleset Include(s) not found: ';
            for (let i = 0; i < missedIncludes.length; i++) {
              errMsg += '<br>- \'' + missedIncludes[i] + '\'';
            }

            callback({
              status: SharedConstants.STATUS_ERROR,
              message: errMsg
            });
          }
        });

      } else {
        callback({
          status: SharedConstants.STATUS_SUCCESS,
          ruleFlow: ruleFlow
        });
      }

    } else {

      callback({
        status: SharedConstants.STATUS_SUCCESS,
        ruleFlow: ruleFlow
      });
    }
  }
}
